import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Star, ThumbsUp, User } from "lucide-react";
import type { Tables } from "@/integrations/supabase/types";

interface ReviewCardProps {
  review: Tables<"property_reviews"> & {
    profiles: Pick<Tables<"profiles">, "first_name" | "last_name"> | null;
  };
  onHelpfulVote: (reviewId: string) => Promise<void>;
}

export const ReviewCard = ({ review, onHelpfulVote }: ReviewCardProps) => {
  return (
    <Card key={review.id} className="p-4">
      <div className="flex items-start justify-between">
        <div className="flex items-center space-x-2">
          <div className="h-10 w-10 rounded-full bg-gray-100 flex items-center justify-center">
            <User className="h-6 w-6 text-gray-400" />
          </div>
          <div>
            <p className="font-medium">
              {review.profiles?.first_name} {review.profiles?.last_name}
            </p>
            <div className="flex items-center space-x-1">
              {Array.from({ length: review.rating || 0 }).map((_, i) => (
                <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
          </div>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onHelpfulVote(review.id)}
          className="space-x-1"
        >
          <ThumbsUp className="h-4 w-4" />
          <span>{review.helpful_votes}</span>
        </Button>
      </div>
      <p className="mt-2 text-muted-foreground">{review.review_text}</p>
    </Card>
  );
};